import {Component, OnDestroy, OnInit} from '@angular/core';
import {ManagementFacade} from '../../../../facade/management.facade';
import {NbDialogRef} from '@nebular/theme';
import {Subscription} from 'rxjs';

@Component({
    selector: 'tart-verify-two-factor',
    templateUrl: './verify-two-factor-dialog.component.html',
    styleUrls: ['./verify-two-factor-dialog.component.scss'],
})
export class VerifyTwoFactorDialogComponent implements OnInit, OnDestroy {

    temporaryPhoneNumber: { value: string; showValue: string; referenceId: string };
    workspaceId: string;
    confirmationOTP: boolean;
    subscriptions: Subscription[] = [];

    constructor(private managementFacade: ManagementFacade, private dialogRef: NbDialogRef<any>) {
    }

    ngOnInit(): void {
        this.setSubscribers();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    verifyPhoneNumberOTP(otp: string): void {
        this.managementFacade.verifyPhoneNumber(otp, this.workspaceId, this.temporaryPhoneNumber);
    }

    resendPhoneNumberOTP(): void {
        this.managementFacade.resendOTP(this.temporaryPhoneNumber.referenceId, this.temporaryPhoneNumber.value);
    }

    setSubscribers(): void {
        this.subscriptions.push(this.managementFacade.getTemporaryPhoneNumber$()
            .subscribe(temporaryPhoneNumber => this.temporaryPhoneNumber = temporaryPhoneNumber));
        this.subscriptions.push(this.managementFacade.getConfirmationOTP$()
            .subscribe(confirmationOTP => {
                this.confirmationOTP = confirmationOTP;
                if(this.confirmationOTP) {
                    this.closeDialog();
                }
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
